<template>
    <div class="bright container-fluid py-3">
        <router-view @childrenRoute="hideNonChildren" />
        <div class="row" v-if="!isChildRoute" id="bright-parent">
            <div class="col-md-12 mb-2">
                <div class="row">
                    <div class="col-md-12">
                        <h4>OVERVIEW STORE</h4>
                    </div>
                </div>
            </div>

            <div class="col-md-8 mb-2">
                <div class="row">
                    <div class="col-md-6">
                        <ListCompare
                            title="SALES"
                            unit="M"
                            div="1000000000"
                            :data="ytd.sales.rekap"
                            itemcol="Info"
                            valuecol="Value"
                            url="/bright/sales"
                        />
                    </div>
                    <div class="col-md-6">
                        <ListCompare
                            title="WASTE"
                            unit="Jt"
                            div="1000000"
                            :data="ytd.waste.rekap"
                            itemcol="Info"
                            valuecol="Value"
                            comp="-1"
                            url="/bright/sales"
                        />
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <ListCompare
                            title="SALES PER DAY"
                            unit="Jt"
                            div="1000000"
                            :data="ytd.sales.spd"
                            itemcol="Info"
                            valuecol="Value"
                            url="/bright/sales"
                        />
                    </div>
                    <div class="col-md-6">
                        <ListCompare
                            title="MARGIN"
                            unit="%"
                            :data="ytd.margin.rekap"
                            itemcol="Info"
                            valuecol="Value"
                            url="/bright/sales"
                        />
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <BarCard
                            title="SALES YTD (M)"
                            :data="ytd.sales.ytdchart"
                            :width="500"
                            :height="280"
                            url="/bright/sales"
                        />
                    </div>
                    <div class="col-md-6">
                        <BarCard
                            title="SALES MTD (M)"
                            :data="ytd.sales.mtdchart"
                            :width="500"
                            :height="280"
                            url="/bright/sales"
                        />
                    </div>
                    <div class="col-md-6">
                        <BarCard
                            title="MARGIN YTD (%)"
                            :data="ytd.margin.ytdchart"
                            :width="500"
                            :height="280"
                            url="/bright/sales"
                        />
                    </div>
                    <div class="col-md-6">
                        <BarCard
                            title="MARGIN MTD (%)"
                            :data="ytd.margin.mtdchart"
                            :width="500"
                            :height="280"
                            url="/bright/sales"
                        />
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-6">
                        <InfoCard
                            info="TOTAL STORE OOS BY AREA"
                            :value="totalOOSStoreByArea"
                            unit="UNIT"
                            :url="'/bright/report2?tab=10&branchtype=BRIGHT&condition=OOS&presentation=10'"
                            :loading="this.loading.oos"
                        />
                    </div>
                    <div class="col-md-6">
                        <InfoCard
                            info="TOTAL STORE OOS BY REGION"
                            :value="totalOOSStoreByRegion"
                            unit="UNIT"
                            :url="'/bright/report2?tab=10&branchtype=BRIGHT&condition=OOS&presentation=10'"
                            :loading="this.loading.oos"
                        />
                    </div>
                    <div class="col-md-6">
                        <ListItem5
                            warning="1"
                            title="STORE OOS BY AREA"
                            :data="oosStoreBySalesArea"
                            prefix="AREA"
                            itemcol="title"
                            valuecol="Cnt"
                            url="/bright/report2?tab=10&branchtype=BRIGHT"
                        />
                    </div>
                    <div class="col-md-6">
                        <ListItem5
                            warning="1"
                            title="STORE OOS BY REGION"
                            :data="oosStoreByRegion"
                            prefix="REGION"
                            itemcol="title"
                            valuecol="Cnt"
                            url="/bright/report2?tab=10&branchtype=BRIGHT"
                        />
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-6">
                        <InfoCard
                            info="TOTAL DC OOS BY AREA"
                            :value="totalOOSDCByArea"
                            unit="UNIT"
                            :url="'/bright/report2?tab=10&branchtype=DC&condition=OOS&presentation=10'"
                            :loading="this.loading.oos"
                        />
                    </div>
                    <div class="col-md-6">
                        <InfoCard
                            info="TOTAL DC OOS BY REGION"
                            :value="totalOOSDCByRegion"
                            unit="UNIT"
                            :url="'/bright/report2?tab=10&branchtype=DC&condition=OOS&presentation=10'"
                            :loading="this.loading.oos"
                        />
                    </div>
                    <div class="col-md-6">
                        <ListItem5
                            warning="1"
                            title="DISTRIBUTION CENTER BY AREA"
                            :data="oosDCBySalesArea"
                            prefix="AREA"
                            itemcol="title"
                            valuecol="Cnt"
                            url="/bright/report2?tab=10&branchtype=DC"
                        />
                    </div>
                    <div class="col-md-6">
                        <ListItem5
                            warning="1"
                            title="DISTRIBUTION CENTER OOS BY REGION"
                            :data="oosDCByRegion"
                            prefix="REGION"
                            itemcol="title"
                            valuecol="Cnt"
                            url="/bright/report2?tab=10&branchtype=DC"
                        />
                    </div>
                </div>
            </div>
            <div class="col-md-4 mb-2">
                <div class="row">
                    <ListItem
                        v-if="false"
                        title="STORES BY AREA"
                        prefix="AREA"
                        :data="store.area"
                        itemcol="SalesArea"
                        valuecol="StoreCnt"
                    />
                    <ListItem
                        title="STORES BY REGION"
                        prefix="REGION"
                        :data="store.region"
                        itemcol="RegionPertareId"
                        valuecol="StoreCnt"
                    />
                    <ListItem
                        title="STORES BY PROVINCE"
                        :data="store.province"
                        itemcol="ProvinceName"
                        valuecol="StoreCnt"
                    />
                </div>
            </div>
        </div>
        <Footer />
    </div>
</template>

<script>
import Bright from "@/components/page/Bright.js";
import {
    Rainbow,
    Rainbow2,
    FuelColor,
    Config,
    AppColors,
    Penanggalan,
    AxiosWithJar,
} from "@/utility.js";
import BarCard from "@/views/pages/BarCard.vue";
import ListItem from "@/views/pages/ListItem.vue";
import ListCompare from "@/views/pages/ListCompare.vue";
import Footer from "@/views/Footer.vue";
import InfoCardComp from "@/views/pages/InfoCardComp.vue";
import ListItem5 from "@/views/pages/ListItem5.vue";
import InfoCard from "@/views/pages/InfoCard.vue";
import OverviewTitleBox from "@/views/component/OverviewTitleBox.vue";

export default {
    extends: Bright,
    components: {
        ListItem,
        ListCompare,
        BarCard,
        Footer,
        //InfoCardComp,
        ListItem5,
        InfoCard,
    },
    mounted() {
        this.hideNonChildren();
        this.loadYTD();
        this.loadStore();
        this.getOOSOverview();
        this.loadOOS();
        //this.displayParentContent()
        //this.$store.state.page=window.location.pathname.split('/')[1]===''?'overview':window.location.pathname.split('/')[1];
        //document.title=this.$store.state.page+' - Dashboard'
    },
    data() {
        return {
            isChildRoute: false,
            url: "",
            oos: [],
            loading: {
                oos: false,
            },
        };
    },
    watch: {
        $route(to, from) {
            this.hideNonChildren();
        },
    },
    computed: {
        currentRouteName() {
            return this.getUri();
        },
        //OOS
        totalOOSStoreByArea() {
            return this.oos?.oos_store_by_sales_area?.data?.reduce(
                (acc, item) => acc + item.Cnt,
                0
            );
        },
        totalOOSStoreByRegion() {
            return this.oos?.oos_store_by_region?.data?.reduce(
                (acc, item) => acc + item.Cnt,
                0
            );
        },
        totalOOSDCByArea() {
            return this.oos?.oos_dc_by_sales_area?.data?.reduce(
                (acc, item) => acc + item.Cnt,
                0
            );
        },
        totalOOSDCByRegion() {
            return this.oos?.oos_dc_by_region?.data?.reduce(
                (acc, item) => acc + item.Cnt,
                0
            );
        },

        //APPEND URL
        oosStoreBySalesArea() {
            return (this.oos?.oos_store_by_sales_area?.data || []).map(
                (item) => ({
                    ...item,
                    //title: `AREA ${item.GroupByField}`,
                    url: `/bright/report2?tab=10&area=${
                        item.title !== null ? item.title : ""
                    }&branchtype=BRIGHT&condition=OOS&presentation=10`,
                })
            );
        },
        oosStoreByRegion() {
            return (this.oos?.oos_store_by_region?.data || []).map((item) => ({
                ...item,
                //title: `AREA ${item.GroupByField}`,
                url: `/bright/report2?tab=10&region=${
                    item.title !== null ? item.title : ""
                }&branchtype=BRIGHT&condition=OOS&presentation=10`,
            }));
        },
        oosDCBySalesArea() {
            return (this.oos?.oos_dc_by_sales_area?.data || []).map((item) => ({
                ...item,
                //title: `AREA ${item.GroupByField}`,
                url: `/bright/report2?tab=10&area=${
                    item.title !== null ? item.title : ""
                }&branchtype=DC&condition=OOS&presentation=10`,
            }));
        },
        oosDCByRegion() {
            return (this.oos?.oos_dc_by_region?.data || []).map((item) => ({
                ...item,
                //title: `AREA ${item.GroupByField}`,
                url: `/bright/report2?tab=10&region=${
                    item.title !== null ? item.title : ""
                }&branchtype=DC&condition=OOS&presentation=10`,
            }));
        },
    },
    methods: {
        hideNonChildren() {
            this.isChildRoute = this.$route.path !== "/bright";
        },
        displayParentContent() {
            document.getElementById("bright-parent").style.display = "inline";
        },
        getUri() {
            let uriPath2 = window.location.pathname.split("/");
            console.log("url: " + uriPath2);
        },
        async loadYTD() {
            let url =
                Config().apiURL +
                "/bright/ytd-overview?" +
                (this.branchid ? "&branchid=" + this.branchid : "");
            await AxiosWithJar()
                .get(url)
                .then((result) => {
                    if (result.data.sales.length) {
                        let field = "RegionPertareId"; //SalesArea //RegionPertareId
                        let prefix = "REGION "; //AREA //REGION
                        this.ytd.sales = {
                            rekap: this.processYTD(
                                result.data.sales,
                                "Info",
                                "SalesExTax",
                                false,
                                "Grup",
                                1,
                                2
                            ),
                            spd: this.processYTD(
                                result.data.sales,
                                "Info",
                                "TotalSPD",
                                "StoreCount",
                                "Grup",
                                1,
                                2
                            ),
                            ytdchart: this.processBarChart(
                                result.data.sales,
                                "Info",
                                "",
                                "SalesExTax",
                                false,
                                field,
                                prefix,
                                1000000000,
                                2,
                                Rainbow,
                                "Grup",
                                [1],
                                true
                            ),
                            mtdchart: this.processBarChart(
                                result.data.sales,
                                "Info",
                                "",
                                "SalesExTax",
                                false,
                                field,
                                prefix,
                                1000000000,
                                2,
                                Rainbow2,
                                "Grup",
                                [2],
                                true
                            ),
                            spdchart: this.processBarChart(
                                result.data.sales,
                                "Info",
                                "",
                                "SalesExTax",
                                "StoreCount",
                                field,
                                prefix,
                                1000000,
                                2,
                                Rainbow,
                                "Grup",
                                [4],
                                true,
                                false,
                                "NumDay"
                            ),
                        };
                        this.ytd.margin = {
                            rekap: this.processYTD(
                                result.data.margin,
                                "Info",
                                "Margin",
                                "SalesExTax",
                                "Grup",
                                0.01,
                                2
                            ),
                            ytdchart: this.processBarChart(
                                result.data.margin,
                                "Info",
                                "",
                                "Margin",
                                "SalesExTax",
                                field,
                                prefix,
                                0.01,
                                2,
                                Rainbow,
                                "Grup",
                                [1],
                                true
                            ),
                            mtdchart: this.processBarChart(
                                result.data.margin,
                                "Info",
                                "",
                                "Margin",
                                "SalesExTax",
                                field,
                                prefix,
                                0.01,
                                2,
                                Rainbow2,
                                "Grup",
                                [2],
                                true
                            ),
                        };
                        this.ytd.waste = {
                            rekap: this.processYTD(
                                result.data.waste,
                                "Info",
                                "Waste",
                                false,
                                "Grup",
                                1,
                                2
                            ),
                            ytdchart: this.processBarChart(
                                result.data.waste,
                                "Info",
                                "",
                                "Waste",
                                false,
                                field,
                                prefix,
                                1000000,
                                2,
                                Rainbow,
                                "Grup",
                                [1],
                                true
                            ),
                            mtdchart: this.processBarChart(
                                result.data.waste,
                                "Info",
                                "",
                                "Waste",
                                false,
                                field,
                                prefix,
                                1000000,
                                2,
                                Rainbow2,
                                "Grup",
                                [2],
                                true
                            ),
                        };
                        this.ytd.reconcile = {
                            rekap: this.processYTD(
                                result.data.reconcile,
                                "Info",
                                "Reconcile",
                                false,
                                "Grup",
                                1,
                                2
                            ),
                            ytdchart: this.processBarChart(
                                result.data.reconcile,
                                "Info",
                                "",
                                "Reconcile",
                                false,
                                field,
                                prefix,
                                1000000,
                                2,
                                Rainbow,
                                "Grup",
                                [1],
                                true
                            ),
                            mtdchart: this.processBarChart(
                                result.data.reconcile,
                                "Info",
                                "",
                                "Reconcile",
                                false,
                                field,
                                prefix,
                                1000000,
                                2,
                                Rainbow2,
                                "Grup",
                                [2],
                                true
                            ),
                        };
                        this.ytd.basket = {
                            invoice: this.processYTD(
                                result.data.basket,
                                "Info",
                                "NoOfInvoice",
                                false,
                                "Grup",
                                1,
                                2
                            ),
                            size: this.processYTD(
                                result.data.basket,
                                "Info",
                                "SalesExTax",
                                "NoOfInvoice",
                                "Grup",
                                1,
                                2,
                                false
                            ),
                        };
                        this.ytd.store = {
                            rekap: this.processYTD(
                                result.data.store,
                                "Info",
                                "TotalStore",
                                false,
                                "Grup",
                                1,
                                2
                            ),
                        };
                    }
                });
        },
        async getOOSOverview() {
            this.urlRequestParams = Config().apiURL;
            this.urlRequestParams += "/v1/bright/oosoverview?";

            //
            //this.urlRequestParams+='&date='+this.tanggal

            this.loading.oos = true;
            //this.loading.isSuccess = false;
            AxiosWithJar()
                .get(this.urlRequestParams)
                .then((response) => {
                    this.oos = response.data;
                    //this.loading.isSuccess = true;
                    console.log("oos overview: " + JSON.stringify(this.oos));
                })
                .catch((error) => {
                    console.log(error);
                    //this.errored = true
                    //error.response.data
                })
                .finally(() => {
                    this.loading.oos = false;
                });
        },
    },
};
</script>
